import React from 'react'

import About from './About.jsx'

export default () => (
  <About id='about4'>
    コンピュータとは縁遠い人間の言葉が確率の魔法で数字になってコンピュータで扱えるようになるの、めちゃくちゃ面白くないですか？
  </About>
)
